<template>
  <div class="study-parameters container">
    <div class="sizer">
      <div class="entry">
        <i class="icon-calendar_check"></i>
        <span class="baseline">{{ $t('dateAndTime') }}</span>
        <span class="description">{{ date }}<br />{{ travelTimeType }} {{ time }}</span>
      </div>
      <div class="entry">
        <i class="icon-directions"></i>
        <span class="baseline">{{ $t('routeType') }}</span>
        <span class="description">{{ travelType }}</span>
      </div>
      <div class="entry">
        <i class="icon-zone"></i>
        <span class="baseline">{{ $t('zone') }}</span>
        <span class="description small">{{ $t('zoneDescription') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['action', 'data'],

  computed: {
    date() {
      if (typeof this.study.date === 'number') {
        // legacy
        return this.$d(new Date(this.data.date * 1000), 'date');
      }

      return this.$d(new Date(this.data.date), 'date');
    },

    travelTimeType() {
      return this.data.travelTimeType === 1 ? this.$t('arrivalAt') : this.$t('departureAt');
    },

    time() {
      let dateTime = new Date(this.study.date);
      if (typeof this.study.date === 'number') {
        // legacy
        dateTime = new Date(this.study.date * 1000);
      }

      return `${dateTime.getHours()}h${dateTime.getMinutes() > 0 ? dateTime.getMinutes() : ''}`;
    },

    travelType() {
      return this.data.travelType === 1 ? this.$t('routeOneWay') : this.$t('routeReturn');
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.study-parameters {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  max-height: 128px;

  .sizer {
    display: flex;
  }
  .entry {
    display: inline-block;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 36.25em;
    padding-right: 6.875em;
    padding-left: 6.875em;
    text-align: center;
    box-sizing: border-box;
    vertical-align: top;
    & + .entry {
      &:before {
        content: '';
        display: block;
        position: absolute;
        right: 100%;
        top: 10%;
        bottom: 0;
        width: 1px;
        background-color: colors.$nude-concrete-color;
      }
    }
    i {
      color: colors.$nude-concrete-color;
      font-size: 6.5em;
      width: 1.4903846154em;
      height: 1.4903846154em;
      border: 1px solid colors.$nude-concrete-color;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto;
      border-radius: 50%;
    }
    .baseline {
      display: block;
      font-size: 1.875em;
      color: colors.$earth-color;
      margin-top: 0.75em;
      margin-bottom: 1em;
      font-weight: 300;
    }
    .description {
      font-size: 2.75em;
      &.small {
        font-size: 1.75em;
      }
    }
  }
}
</style>
